import React, { useState } from 'react';
import { Layout, Menu, Button, Typography, Space } from 'antd';
import {
    DashboardOutlined,
    GlobalOutlined,
    TagsOutlined,
    CheckSquareOutlined,
    PictureOutlined,
    CalendarOutlined,
    SolutionOutlined,
    PhoneOutlined,
    LogoutOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    SettingOutlined
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/slices/authSlice';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const AppLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
        { key: '/tours', icon: <GlobalOutlined />, label: 'Tour Packages' },
        { key: '/inclusions', icon: <CheckSquareOutlined />, label: 'Inclusions' },
        { key: '/tags', icon: <TagsOutlined />, label: 'Common Tags' },
        { key: '/gallery', icon: <PictureOutlined />, label: 'Gallery' },
        { key: '/inquiries', icon: <SolutionOutlined />, label: 'Inquiries' },
        { key: '/leads', icon: <PhoneOutlined />, label: 'Leads' },
        { key: '/custom-tours', icon: <CalendarOutlined />, label: 'Custom Tours' },
        { key: '/static-content', icon: <SettingOutlined />, label: 'Static Content' },
    ];

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider trigger={null} collapsible collapsed={collapsed} theme="dark" width={240}>
                <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#001529', marginBottom: 16 }}>
                    <Title level={4} style={{ color: 'white', margin: 0 }}>{!collapsed ? 'VSP TOURS ADMIN' : 'VSP'}</Title>
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    onClick={({ key }) => navigate(key)}
                />
            </Sider>
            <Layout>
                <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                    {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                        className: 'trigger',
                        onClick: () => setCollapsed(!collapsed),
                        style: { fontSize: 18, cursor: 'pointer' }
                    })}
                    <Button type="text" icon={<LogoutOutlined />} onClick={handleLogout}>Logout</Button>
                </Header>
                <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', borderRadius: 8, minHeight: 280, overflow: 'initial' }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
